import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const Cross = ({ onClick }) => {
  return (
    <div onClick={onClick} className="cross-container">
      <div className="cross-bar" />
      <div className="cross-bar" />
      <div className="cross-bar" />
    </div>
  );
};

Cross.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Cross;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/SideBar/components/Cross/index.js
 **/